<template>
    <div :class="{ 'is-loading': loading }">
        <Loader :class="[{ show: loading }, 'fixed']" />
        <PressFilters @filters-updated="flltersUpdated" />
        <PressResults :results="results" :error-messages="errorMessages" :has-error="hasError" />
        <PagingBar
            v-if="!hasError && resultsCount > 0"
            :key="paginationUpdateKey"
            :results-count="resultsCount"
            :default-page="paging.page"
            :default-page-size="paging.pageSize"
            @paging-updated="pagingUpdated" />
    </div>
</template>

<script>
import * as lib from 'Root/lib/lib.js'

import ajaxMixins from 'Root/vue/mixins/ajaxMixins'
import Loader from 'Root/vue/components/Loader.vue'
import PressFilters from 'Root/vue/components/Press/PressFilters.vue'
import PressResults from 'Root/vue/components/Press/PressResults.vue'
import PagingBar from 'Root/vue/components/PagingBar.vue'

export default {
    components: {
        Loader,
        PressFilters,
        PressResults,
        PagingBar,
    },

    mixins: [ajaxMixins],

    data() {
        return {
            initialized: false,
            loading: false,
            hasError: false,
            errorMessages: '',

            filters: {
                year: '',
                tags: '',
            },

            paging: {
                currentPage: 1,
                pageSize: this.appData.pageSizeOptions[0],
            },

            results: [],
            resultsCount: -1,

            paginationUpdateKey: 0,
        }
    },

    mounted() {
        this.getResults()
        this.initialized = true
    },

    methods: {
        getResults() {
            const payload = {
                year: this.filters.year,
                tags: this.filters.tags,
                page: this.paging.currentPage,
                pageSize: this.paging.pageSize,
            }

            if (this.initialized) {
                lib.moveWindowToObj(jQuery(this.$el), -40)
            }

            this.ajax(this.appData.configuration.resultsEndpoint, payload, this.storeResults)
        },

        flltersUpdated(filters) {
            this.filters.year = filters.year
            this.filters.tags = filters.tags
            this.paging.currentPage = 1
            this.paginationUpdateKey++

            if (this.initialized) {
                this.getResults()
            }
        },

        pagingUpdated(data) {
            this.paging.currentPage = data.page
            this.paging.pageSize = data.pageSize

            if (this.initialized) {
                this.getResults()
            }
        },

        storeResults(data) {
            this.resultsCount = data.resultsCount
            this.results = data.results
        },
    },
}
</script>
